import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import p2pNavigationService from "../services/p2pNavigation.service";
import StorageService from "../services/StorageService";
import SuperAdminStorageService from "../services/SuperAdminStorageService";
import { SUPER_ADMIN_P2P_CONTEXT } from "./SuperAdminP2PNavigationProvider";

const P2PNavigationContext = createContext({
  loading: true,
  ctx: null,
  reload: async () => {},
});

export function P2PNavigationProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [ctx, setCtx] = useState(null);

  const reload = useCallback(async () => {
    if (!StorageService.isAuthenticated()) {
      setCtx(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await p2pNavigationService.getContext();
      setCtx(res?.data || null);
    } catch (e) {
      setCtx(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const value = useMemo(() => ({ loading, ctx, reload }), [loading, ctx, reload]);

  return (
    <P2PNavigationContext.Provider value={value}>{children}</P2PNavigationContext.Provider>
  );
}

export function useP2PNavigation() {
  const location = useLocation();
  const base = useContext(P2PNavigationContext);

  if (
    location.pathname.startsWith("/super-admin/p2p") &&
    SuperAdminStorageService.isAuthenticated()
  ) {
    return {
      loading: false,
      ctx: SUPER_ADMIN_P2P_CONTEXT,
      reload: async () => {},
    };
  }

  return base;
}

export default P2PNavigationContext;
